export const maskValue = (value, maskType) => {

    if (!value) return value;

    switch (maskType.toLowerCase()) {

        case 'pan':

            // Keep first 5 and last 1 visible, mask 4 middle chars

            return value.replace(/^(.{5})(.{4})(.)$/, (_, p1, _p2, p3) => `${p1}XXXX${p3}`);



        case 'aadhaar':

            // only last four digits

            if (/^\d{4}$/.test(value)) {

                return `xxxx xxxx ${value}`;

            }

            // If Aadhaar is in format ********1234

            if (/^\*{8}\d{4}$/.test(value)) {

                return `xxxx xxxx ${value.slice(-4)}`;

            }

            // Mask first 8 digits, keep last 4

            return value.replace(/^(\d{4})\s?(\d{4})\s?(\d{4})$/, (_, _p1, _p2, p3) => `xxxx xxxx ${p3}`);



        case 'mobilenumber':

            // Mask first 6 digits

            return value.replace(/^(\d{6})(\d{4})$/, 'xxxxxx$2');



        case 'dob':

            // Match YYYY-MM-DD format

            const matchYMD = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);

            if (matchYMD) {

                const [, year] = matchYMD;

                return `XX-XX-${year}`;

            }



            // Match DD-MM-YYYY format

            return value.replace(/^(\d{2})-(\d{2})-(\d{2})(\d{2})$/, 'XX-XX-$3$4');



        case 'email':

            // Mask all except first and last character of local part, and domain

            return value.replace(/^(.)([^@]*)(@)([^.]+)(\..*)$/, (_, p1, p2, p3, p4, p5) => {

                const maskedLocal = `${p1}${'x'.repeat(p2.length)}`;

                const maskedDomain = 'X'.repeat(p4.length);

                return `${maskedLocal}${p3}${maskedDomain}${p5}`;

            });



        case 'pincode':

            // Mask last 5 digits

            return value.replace(/^(\d)(\d{5})$/, (_, p1) => `${p1}XXXXX`);



        case 'voterid':

            // Keep 1st and last 2 chars, mask the rest

            return value.replace(

                /^(.)(.*)(.{2})$/,

                (_, p1, p2, p3) => `${p1}${'X'.repeat(p2.length)}${p3}`

            );



        case 'passport':

            // Keep 1st and last char, mask middle

            return value.replace(/^(.)(.*)(.)$/, (_, p1, p2, p3) => `${p1}${'X'.repeat(p2.length)}${p3}`);



        case 'dl':

            // Mask everything after the first 4 characters

            return value.replace(/^(.{4})(.*)$/, (_, p1, p2) => `${p1}${'X'.repeat(p2.length)}`);

        case 'ckyc':
            // Remove non-digits first
            const cleanCkyc = value.replace(/\D/g, '');

            // Must be 14 digits
            if (cleanCkyc.length === 14) {
                return `${'X'.repeat(10)}${cleanCkyc.slice(-4)}`;
            }

            return value;


        case 'address':

            return value.replace(/(\d)(\d{5})(?!\d)/, '$1XXXXX');



        default:

            return value;

    }

};